import React, { Component } from "react";
import PropTypes from "prop-types";

import Button from "components/library/Button";
import TextInput from "components/library/TextInput";
import Icon from "components/library/Icon";

import styles from "./ImageMeta.css";

export default class ImageMeta extends Component {
  constructor(props) {
    super(props);
    this.setAltText = this._setAltText.bind(this);
    this.submitImage = this._submitImage.bind(this);
    this.state = {
      meta: { alt_text: this.props.suggestedAltText || "" },
      wasClicked: false,
    };
  }

  componentDidMount() {
    if (this.props.skip) {
      this.submitAndContinue();
    }
  }

  submitAndContinue() {
    this.props.setLoadingState(true);
    return this.props.submitImage().then(() => {
      this.props.nextStep();
    });
  }

  _setAltText(event) {
    event.preventDefault();
    this.setState({
      meta: {
        ...this.state.meta,
        alt_text: event.target.value,
      },
    });
  }

  _submitImage(event) {
    event.preventDefault();
    this.setState({ wasClicked: true });
    return this.props
      .addMeta(this.state.meta)
      .then(() => {
        this.submitAndContinue();
      })
      .catch(() => {
        this.setState({ wasClicked: false });
      });
  }

  render() {
    const { thumbnail } = this.props;
    const alt_text = this.state.meta.alt_text;

    return (
      <div className={styles.root}>
        <h1>Text for visually impaired users</h1>
        <div className={styles.thumbnailContainer}>
          <img className={styles.thumbnail} src={thumbnail} />
          <Icon name="check/rounded" className={styles.check} />
        </div>
        <TextInput
          aria-labelledby="alt-description"
          autoFocus={true}
          className={styles.altText}
          error={this.props.errors.alt_text ? this.props.errors.alt_text : null}
          fullWidth
          label="Image alt text"
          labelDisplay="visible"
          onChange={this.setAltText}
          placeholder="Describe the image, e.g. “Saudi Crown Prince Mohammed bin Salman at the United Nations”"
          type="text"
          value={alt_text}
        />
        <div className={styles.altDescription} id="alt-description">
          <p>
            Alt text should describe the physical appearance of an image and who
            or what is in it. It isn’t a caption, which gives context for people
            who can already see the photo.
          </p>
          <p>
            <strong>Why it matters:</strong> Visually impaired readers hear this
            text instead of seeing the image. Plus it helps rank us higher in
            search engines.
          </p>
        </div>
        <div className={styles.buttonGroup}>
          <Button
            type="submit"
            onClick={this.submitImage}
            isDisabled={this.state.wasClicked}
          >
            Finish
          </Button>
          <Button
            role="link"
            onClick={() => this.props.history.go(-1)}
            type="cancel"
            aria-label="Cancel image uploading/editing and go back to the text editor"
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

ImageMeta.propTypes = {
  history: PropTypes.shape({
    go: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }),
  thumbnail: PropTypes.string.isRequired,
  addMeta: PropTypes.func.isRequired,
  submitImage: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  setLoadingState: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  suggestedAltText: PropTypes.string,
};
